// extracted by mini-css-extract-plugin
export default {"addCoffeeBtn":"Plan_addCoffeeBtn__noAqi"};